import { render, staticRenderFns } from "./CouponList2.vue?vue&type=template&id=21c8c48e&scoped=true&"
import script from "./CouponList2.vue?vue&type=script&lang=js&"
export * from "./CouponList2.vue?vue&type=script&lang=js&"
import style0 from "../../less/order.less?vue&type=style&index=0&id=21c8c48e&lang=less&scoped=true&"
import style1 from "./CouponList2.vue?vue&type=style&index=1&id=21c8c48e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c8c48e",
  null
  
)

export default component.exports